import React from "react";
import { useSelector } from "react-redux";
import { useReadOnly } from "../../../hooks/useReadOnly";
import { signedLockedAccess } from "../../../utils/commonHelper";
import { StatusBanner } from "../StatusBanner";

interface SectionBannersProps {
  className?: string;
}

export const SectionBanners: React.FC<SectionBannersProps> = ({ className }) => {
  const isReadOnly = useReadOnly();
  const assessmentDetails = useSelector((state: any) => state.patient.detailAssessment);

  const isSignedLocked = !signedLockedAccess(assessmentDetails?.assessmentStage);

  if (!isReadOnly && !isSignedLocked) return null;

  return (
    <div data-testid="section-banners" className={className} style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "16px" }}>
      {isReadOnly && <StatusBanner preset="readOnly" layout="inline" />}
      {isSignedLocked && <StatusBanner preset="signedLocked" layout="inline" />}
    </div>
  );
};
